/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconDesktop16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconDesktop16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.334 6.533c0-1.746 0-2.618.393-3.26.22-.358.522-.66.88-.88C3.25 2 4.121 2 5.867 2h4.267c1.746 0 2.619 0 3.26.393.359.22.66.522.88.88.393.642.393 1.514.393 3.26V6.8c0 1.746 0 2.619-.393 3.26-.22.359-.521.66-.88.88-.572.351-1.33.389-2.727.393v1.334l1.334.333v1H4v-1l1.333-.333v-1.334c-1.397-.004-2.154-.042-2.727-.393a2.667 2.667 0 0 1-.88-.88c-.393-.641-.393-1.514-.393-3.26v-.267Zm4.533-3.2h4.267c.899 0 1.48.002 1.918.043.419.04.57.107.645.154.18.11.33.26.44.44.047.076.114.226.154.645.042.44.043 1.02.043 1.918V6.8c0 .899-.001 1.48-.043 1.918-.04.419-.107.57-.154.645-.11.18-.26.33-.44.44-.076.047-.226.114-.645.154-.439.042-1.02.043-1.918.043H5.867c-.898 0-1.479-.001-1.918-.043-.419-.04-.57-.107-.645-.153-.18-.11-.33-.261-.44-.44-.047-.077-.114-.227-.154-.646-.041-.439-.043-1.02-.043-1.918v-.267c0-.898.002-1.479.043-1.918.04-.419.107-.57.154-.645.11-.18.26-.33.44-.44.076-.047.226-.114.645-.154.44-.041 1.02-.043 1.918-.043Zm.8 8v1.334h2.667v-1.334H6.667Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconDesktop24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconDesktop24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2 9.8c0-2.619 0-3.928.59-4.89a4 4 0 0 1 1.32-1.32C4.872 3 6.181 3 8.8 3h6.4c2.619 0 3.928 0 4.89.59a4 4 0 0 1 1.32 1.32c.59.962.59 2.271.59 4.89v.4c0 2.619 0 3.928-.59 4.89-.33.538-.782.99-1.32 1.32-.858.527-1.994.583-4.09.59v2l2 .5V21H6v-1.5l2-.5v-2c-2.096-.007-3.231-.063-4.09-.59a4 4 0 0 1-1.32-1.32C2 14.128 2 12.819 2 10.2v-.4ZM8.8 5h6.4c1.348 0 2.219.002 2.877.065.628.06.854.16.968.23a2 2 0 0 1 .66.66c.07.114.17.34.23.968.063.658.065 1.529.065 2.877v.4c0 1.348-.002 2.219-.065 2.877-.06.629-.16.854-.23.968a2 2 0 0 1-.66.66c-.114.07-.34.17-.968.23-.658.063-1.529.065-2.877.065H8.8c-1.348 0-2.219-.002-2.877-.065-.629-.06-.854-.16-.968-.23a2 2 0 0 1-.66-.66c-.07-.114-.17-.34-.23-.968C4.002 12.419 4 11.548 4 10.2v-.4c0-1.348.002-2.219.065-2.877.06-.629.16-.854.23-.968a2 2 0 0 1 .66-.66c.114-.07.34-.17.968-.23C6.581 5.002 7.452 5 8.8 5ZM10 17v2h4v-2h-4Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconDesktop = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconDesktop(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '16':
            return <IconDesktop16 {...iconProps} />;
        case '24':
            return <IconDesktop24 {...iconProps} />;
        default:
            return <IconDesktop24 {...iconProps} />;
    }
});
